// extracted by mini-css-extract-plugin
module.exports = {"container":"WhySection_container__Q2WT_","image":"WhySection_image__xcg4i","title":"WhySection_title__TpboP"};